@if (dumb()) {
    <section class="wrapper breadcrumb" [class.light]="light()" [class.white]="white()">
        <p class="segment clickable" (libAccessibleClick)="goHome()">Home</p>
        <span>/</span>
        <p class="segment">{{ dumbLabel() }}</p>
    </section>
} @else {
    @if (fadeAnimation() && showFade() && !isMobile()) {
        <div class="breadcrumb-fade-right"></div>
    }
    <section class="wrapper breadcrumb" [class.light]="light()" #scrollBreadcrumb>
        @if (isLoading()) {
            <div class="skeleton-wrapper">
                <ng-container *ngTemplateOutlet="skeletonService?.rectangleTemplate() || null"></ng-container>
            </div>
        } @else {
            @for (segment of segments(); track segment.name; let idx = $index; let last = $last) {
                @if (segment.name) {
                    @if (isClickable(idx)) {
                        <p class="segment clickable" (libAccessibleClick)="clickSegment(segment)">
                            {{ segment.name }}
                        </p>
                        @if (!last) {
                            <span>/</span>
                        }
                    } @else {
                        <p class="segment">{{ segment.name }}</p>
                    }
                }
            }
        }
    </section>
}
